import { createContext, useContext, useState, ReactNode} from 'react';
import { userType } from '../../type/UserType';

interface UserContextType {
    userData: userType | null;
    setUserData: (userData: userType  | null) => void;
    theme: string,
    setTheme: (theme:string) => void,
}
const userContextInfo = createContext<UserContextType>({
    userData: null,
    setUserData: () => {},
    theme: "",
    setTheme: ()=>{},
});

interface PersonProviderProps {
  children: ReactNode;
}


export const UserProvider = ({ children} :PersonProviderProps)=>{
    const [userData, setUserData] = useState<userType | null>(null);
    const [theme, setTheme] = useState<string>("client")
    return(
        <userContextInfo.Provider value={{userData: userData, setUserData: setUserData, theme: theme, setTheme: setTheme}}>
            {children}
        </userContextInfo.Provider>
    )
}

export const UserConsumer = ()=>{
    return useContext(userContextInfo);
}
